import { AppBar, Box, Button, Container, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, SwipeableDrawer, Toolbar } from '@mui/material';
import { InboxIcon, MailIcon, MenuIcon, Plus, Rows3, User } from 'lucide-react';
import React from 'react'
import styled, { useTheme } from 'styled-components';
import NotificationMenu from '../../NotificationMenu/NotificationMenu';
import { useNavigate } from 'react-router-dom';
import { Logout } from '@mui/icons-material';
import { signOut } from '../../../api/authentication/Logout';
import LocalStorage from '../../../helper/Generic/LocalStorage';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../Redux/user/user';
import { useMatchPreviewFiltersService } from '../../../context/useMatchPreviewFiltersService';
import { useMatchPreviewService } from '../../../context/useMatchPreviewService';

const MobileHeader = () => {

    const { setMatchPreviewFiltersModalOpen } = useMatchPreviewFiltersService();
    const { setProjectedLineupOpen, projectedLineupOpen } = useMatchPreviewService();

    const [open, setOpen] = React.useState(false);
    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };
    const dispatch = useDispatch();

    const theme = useTheme();

    const navigate = useNavigate();

    const handleSelect = (path) => {
        // Close ProjectedLineupMobileModal if open
        setProjectedLineupOpen(false);

        navigate(path);
    };


    const handleLogout = () => {
        signOut(
            LocalStorage.getAuthenticationToken(),
            function () {
                LocalStorage.setAuthenthicationToken(null);
                LocalStorage.setRefreshToken(null);
                dispatch(logoutUser());
                navigate("/");
            },
            function (error) {
                notifyError("Something wrong")
            }
        );
    };



    const menuItems = [
        {

            text: "Match Preview",
            icon: <Rows3 />,
            goTo: "/leagues/match_preview"
        },

    ]
    const bottomItems = [
        {

            text: "Profile",
            icon: <User />,
            goTo: "/userprofile"
        },

    ]


    const DrawerList = (
        <Box sx={{ display: "flex", flexDirection: "column", width: 250, height: '100%' }} role="presentation" onClick={toggleDrawer(false)}>
            <List>
                {menuItems.map((item, index) => (
                    <ListItem key={item.text} disablePadding onClick={() => handleSelect(item.goTo)}>
                        <ListItemButton>
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <Divider sx={{ mt: 'auto' }} />
            <List>
                {bottomItems.map((item, index) => (
                    <ListItem key={item.text} disablePadding onClick={() => handleSelect(item.goTo)}>
                        <ListItemButton>
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
                <ListItem disablePadding onClick={() => handleLogout()}>
                    <ListItemButton style={{ color: "red" }}>
                        <ListItemIcon>
                            <Logout style={{ color: "red" }} />
                        </ListItemIcon>
                        <ListItemText primary={"Logout"} />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <>
            <AppBar component={"nav"}>
                <Toolbar position="static" style={{ gap: "10px" }}>
                    <IconButton onClick={toggleDrawer(true)}>
                        <MenuIcon color={theme.buttonTextColor} />
                    </IconButton>

                    {window.location.pathname === "/leagues/match_preview" && !projectedLineupOpen &&
                        <Button variant="contained" onClick={() => setMatchPreviewFiltersModalOpen(true)} style={{ background: "rgba(0, 18, 41, 0.8) " }}>
                            Filters
                            <Plus />
                        </Button>
                    }
                    <HeaderContentWrapper>
                        <NotificationMenu />
                    </HeaderContentWrapper>
                </Toolbar>
            </AppBar>
            <SwipeableDrawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
            </SwipeableDrawer>
        </>
    );
}

export default MobileHeader

const HeaderContentWrapper = styled.div`
display:flex;
align-items:center;
gap:10px;
flex-wrap:wrap;
margin-left:auto;
`
